export default "__VITE_ASSET__iU4$tCm___"